import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortingState } from '@tanstack/react-table';
import { RootState } from '..';
import { RESET_ALL_ACTION } from '../actions';

type ViewState = {
  dataTableView?: DataTableState;
};

type DataTableState = {
  page?: number;
  sorting?: SortingState;
  searchTerm?: string;
};

export type PatientViewState = {
  locations: { [location: string]: ViewState };
};

const initialState: PatientViewState = {
  locations: {}
};

export type LocationViewState = {
  location: string;
  viewState: ViewState;
};

const slice = createSlice({
  name: 'patientView',
  initialState,
  extraReducers: (builder) => builder.addCase(RESET_ALL_ACTION, () => initialState),
  reducers: {
    setPatientViewState: (state, { payload: viewState }: PayloadAction<LocationViewState>) => {
      state.locations[viewState.location] = viewState.viewState;
    }
  }
});

export default slice.reducer;

export const { setPatientViewState } = slice.actions;

export const getViewStateForLocation =
  (location: string) =>
  (state: RootState): ViewState | null => {
    return state.patientView.locations[location] || null;
  };
